<!DOCTYPE html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar [user]="user" [title]="title" [back]="true" [destination]=""></app-toolbar>
</ng-container>
<h2 style="text-align: center; padding-top: 20px; padding-bottom: 20px">Status applicazione</h2>
<!--
<ng-container *ngIf="isDataAvailable">
  <div class = "row">
    <div class="column" style="background-color: #e4e5e0">
      <app-doughnut-chart-global-patients></app-doughnut-chart-global-patients>
    </div>
    <div class = "column" style="background-color: #c2d4cc">
      <app-doughnut-chart-personal-patients></app-doughnut-chart-personal-patients>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-inactive-patients></app-bar-chart-inactive-patients>
  </div>
</ng-container>

<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-stable-unstable-uc></app-bar-chart-stable-unstable-uc>
  </div>
</ng-container>
<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-stable-unstable-crohn></app-bar-chart-stable-unstable-crohn>
  </div>
</ng-container>
<div>_________________________________________________</div>
<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-never-logged></app-bar-chart-never-logged>
  </div>
</ng-container>
<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-never-logged-category></app-bar-chart-never-logged-category>
  </div>
</ng-container>
<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-never-logged-pathology></app-bar-chart-never-logged-pathology>
  </div>
</ng-container>
<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-never-logged-sex></app-bar-chart-never-logged-sex>
  </div>
</ng-container>
<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-never-logged-age></app-bar-chart-never-logged-age>
  </div>
</ng-container>
<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-never-logged-age-from-user></app-bar-chart-never-logged-age-from-user>
  </div>
</ng-container>

<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-never-logged-pathology-duration></app-bar-chart-never-logged-pathology-duration>
  </div>
</ng-container>

<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-never-logged-pathology-duration-from-user></app-bar-chart-never-logged-pathology-duration-from-user>
  </div>
</ng-container>
<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-never-logged-age-of-diagnosis></app-bar-chart-never-logged-age-of-diagnosis>
  </div>
</ng-container>
<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-never-logged-activetherapy></app-bar-chart-never-logged-activetherapy>
  </div>
</ng-container>
<ng-container *ngIf="isDataAvailable">
  <div class="row" style="background-color: #e4e5e0; border: 3px solid #008d8d;box-shadow: 3px 3px 2px grey;">
    <app-bar-chart-never-logged-interventi></app-bar-chart-never-logged-interventi>
  </div>
</ng-container>-->

<mat-card>
  <mat-card-title>Descrittiva utilizzo IBD Tool</mat-card-title>
  <mat-card-subtitle>In questa sezione puoi trovare un'analisi generale riguardante:<br>
    <ul>
      <li>Pazienti globali e personali</li>
      <li>Pazienti inattivi o che non hanno mai effettuato l'accesso</li>
      <li>Questionari</li>
      <li>Altre informazioni</li>
    </ul></mat-card-subtitle>
  <mat-card-content>
    <app-box-dashboard title="Pazienti globali" route="/global-patients-section" image="num_pazienti.png"></app-box-dashboard>
    <app-box-dashboard title="Pazienti personali" route="/personal-patients-section" image="num_pazienti.png"></app-box-dashboard>
    <app-box-dashboard title="Inattivi" route="/inactive-patients-section" image="inactive.png"></app-box-dashboard>
    <app-box-dashboard title="Nessun accesso" route="/never-logged-patients-section" image="inactive.png"></app-box-dashboard>
    <app-box-dashboard title="Questionari" route="/table-questionnaires" image="questionari.png"></app-box-dashboard>
    <app-box-dashboard title="Altre informazioni" route="/average-retention" image="info.png"></app-box-dashboard>

<div style="clear:both;"></div>
  </mat-card-content>
</mat-card>
<br>

<mat-card>
  <mat-card-title>Descrittiva pazienti con 2 o più punti di osservazione
  </mat-card-title>
  <mat-card-subtitle>In questa sezione puoi trovare un'analisi sui <span style="font-weight: bold;">pazienti stabili - in miglioramento - in peggioramento</span> sulla base di:<br>
</mat-card-subtitle>  <mat-card-content>
    <app-box-dashboard title="Patologia" route="/stable-unstable-pathology" image="diagnosi.png"></app-box-dashboard>
    <app-box-dashboard title="Fascia d'età" route="/stable-unstable-age" image="eta.png"></app-box-dashboard>
    <app-box-dashboard title="Sesso" route="/stable-unstable-gender" image="sesso.png"></app-box-dashboard>
    <app-box-dashboard title="Malattia iniziale attiva" route="/stable-unstable-malattia-iniziale" image="check.png"></app-box-dashboard>
    <app-box-dashboard title="Tipo terapia attiva" route="/stable-unstable-therapy-active" image="options.png"></app-box-dashboard>
    <app-box-dashboard title="Precedenti chirurgici" route="/stable-unstable-interventi" image="interventi.png"></app-box-dashboard>
    <app-box-dashboard title="Durata malattia" route="/stable-unstable-duration" image="orologio.png"></app-box-dashboard>
<div style="clear:both;"></div>
  </mat-card-content>
</mat-card>
<br>

<mat-card>
  <mat-card-title>Efficienza IBD Tool</mat-card-title>
  <mat-card-subtitle>In questa sezione puoi trovare un'analisi approfondita su:<br>
    <ul>
      <li>Pazienti inattivi</li>
      <li>Pazienti che non hanno mai effettuato l'accesso</li>
    </ul>
    </mat-card-subtitle>
  <mat-card-content>
    <app-box-dashboard title="Analisi utenti che non hanno effettuato l'accesso" route="/never-logged" image="inactive.png"></app-box-dashboard>
    <app-box-dashboard title="Analisi utenti inattivi" route="/inactive" image="inactive.png"></app-box-dashboard>
    <app-box-dashboard title="Risultati 'Questionario di Gradimento'" route="/questionnaire-gradimento/score-avg" image="customer-satisfaction.png"></app-box-dashboard>

<div style="clear:both;"></div>
  </mat-card-content>
</mat-card>
<br>


<br>